import { useMutation, useQuery, useQueryClient } from "react-query";
import apiService from "../../service/apiService";
import { useCookie } from "../useCookie";
import { useToast } from "../useToast";
import { general } from "../../locales/general";
import { useMemo } from "react";

export const useServiceCategoriesQuery = () => {
  const { token } = useCookie("vToken");
  const queryClient = useQueryClient();
  const { toastError, toastSuccess } = useToast();

  const { data, isLoading } = useQuery<ServiceCategory[]>(
    ["getAllServiceCategories"],
    (query) => {
      return apiService.MakeGetRequest("service-categories", token);
    },
  );
  const deleteServiceCategory = useMutation((id: string) => {
    return apiService.MakeDeleteRequest(`service-categories/${id}`, token);
  });

  const arrangedCities = useMemo(() => {
    const results = data?.sort(function (a, b) {
      if (a.label < b.label) {
        return -1;
      }
      if (a.label > b.label) {
        return 1;
      }
      return 0;
    });
    return results || [];
  }, [data]);

  return {
    Cities: arrangedCities,
    isLoading: isLoading,
    deleteServiceCategory(id: string) {
      deleteServiceCategory.mutate(id, {
        onError(error) {
          toastError(general.fr.message.operationFailed);
        },
        onSuccess() {
          toastSuccess(general.fr.message.categoryDeleted);
          queryClient.invalidateQueries("getAllServiceCategories");
        },
      });
    },
    mutating: deleteServiceCategory.isLoading,
  };
};
